import { Http } from '@angular/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable()
export class ConfigService {

    private _settings: any;

    private baseUri: string = 'api/Config/';

    constructor(private http: Http) { }

    get settings(): Observable<any> {
        if (this._settings == null) {
            return this.http.get(this.baseUri + 'Json').map((x) => {
                return this._settings = x.json();
            });
        } else {
            return Observable.of(this._settings);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Service/config.service.ts
 **/